import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { fetchProfessions, deleteProfession } from '../../utils/api';
import MasterDataTable from '../../components/MasterDataTable';

const columns = [
  { id: 'professionId', label: 'ID', minWidth: 50 },
  { id: 'professionName', label: 'Profession Name', minWidth: 170 },
  { id: 'description', label: 'Description', minWidth: 300 },
];

const ProfessionList = ({ onEdit, searchQuery = '' }) => {
  const [professions, setProfessions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  useEffect(() => {
    let cancelled = false;
    const loadProfessions = async () => {
      setLoading(true);
      try {
        const response = await fetchProfessions();
        if (cancelled) return;
        setProfessions(response.data);
        setError(null);
      } catch (err) {
        console.error('Error fetching professions:', err);
        if (!cancelled) {
          setError('Failed to load professions. Please try again later.');
          setProfessions([]);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    loadProfessions();
    return () => {
      cancelled = true;
    };
  }, [refreshTrigger]);

  const handleDelete = async (profession) => {
    try {
      await deleteProfession(profession.professionId, {
        previousData: profession,
        identifier: profession.professionName
      });
      setRefreshTrigger(prev => prev + 1);
    } catch (err) {
      console.error('Error deleting profession:', err);
      alert('Failed to delete profession. It may be referenced by other records.');
    }
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Professions
      </Typography>
      
      <MasterDataTable
        persistKey="profession"
        data={professions}
        columns={columns}
        isLoading={loading}
        searchQuery={searchQuery}
        onEdit={onEdit}
        onDelete={handleDelete}
        emptyMessage="No professions found. Add your first profession!"
      />
      
      {error && (
        <Typography color="error" sx={{ mt: 2 }}>
          {error}
        </Typography>
      )}
    </Box>
  );
};

export default ProfessionList; 